(function () {
  if (!window.customElements) {
    return;
  }

  if (customElements.get('cart-drawer-recommendation')) {
    return;
  }

  class CartDrawerRecommendation extends HTMLElement {
    connectedCallback() {
      this.fetchRecommendation();
    }

    fetchRecommendation() {
      var url = this.getAttribute('data-url');
      if (!url) {
        return;
      }

      fetch(url)
        .then(function (response) {
          if (!response.ok) {
            throw new Error('cart-drawer-recommendation: bad response');
          }
          return response.text();
        })
        .then(
          function (text) {
            var wrapper = document.createElement('div');
            wrapper.innerHTML = text;
            var recommendation = wrapper.querySelector('.cart-drawer-recommendation');

            if (recommendation) {
              this.innerHTML = '';
              this.appendChild(recommendation);
            } else {
              // Sem recomendacao disponivel em stock: nao mostra nada.
              this.remove();
            }
          }.bind(this)
        )
        .catch(function () {
          // Falha silenciosa: a gaveta do carrinho continua a funcionar
          // normalmente, apenas sem a recomendacao.
        });
    }
  }

  customElements.define('cart-drawer-recommendation', CartDrawerRecommendation);
})();
